import { Api, Req } from "@quipa/api";

const getScopedAccountId = (accountId?: number): number => {
    if (typeof window === "undefined") {
        return Number(accountId || 0);
    }
    const ownerAccountId = Number(localStorage.getItem("ownerAccountId") || "0");
    if (ownerAccountId > 0) {
        return ownerAccountId;
    }
    if (Number(accountId) > 0) {
        return Number(accountId);
    }
    return Number(localStorage.getItem("accountId") || "0");
};

const withScopedAccountId = <T extends any>(payload: T): T => {
    if (!payload || typeof payload !== "object") {
        return payload;
    }
    const scopedAccountId = getScopedAccountId((payload as any).accountId);
    if (!(scopedAccountId > 0)) {
        return payload;
    }
    return {
        ...(payload as any),
        accountId: scopedAccountId,
    };
};

export const getNextWorkOrderNum = (accountId: number) =>
    Api.createAction(
        Api.GET_NEXT_WORKORDER_NUM,
        { accountId: getScopedAccountId(accountId) },
        { authenticated: true }
    );

export const createWorkOrder = (workOrder: Api.AddWorkOrderAction[Req]) =>
    Api.createAction(Api.ADD_WORKORDER, withScopedAccountId(workOrder), { authenticated: true });

export const editWorkOrder = (workOrder: Api.EditWorkOrderAction[Req]) =>
    Api.createAction(Api.EDIT_WORKORDER, withScopedAccountId(workOrder), { authenticated: true });

export const searchWorkOrders = (accountId: number) =>
    Api.createAction(
        Api.SEARCH_WORKORDERS,
        { accountId: getScopedAccountId(accountId) },
        { authenticated: true }
    );

export const getWorkOrderPdfContent = (draperyOrderId: number) => Api.createAction(Api.GET_WORKORDER_PDF_CONTENT, { draperyOrderId }, { authenticated: true });

export const getWorkOrderRecommendation = (draperyOrderId: number, type: "panel" | "yardage") => Api.createAction(Api.GET_WORKORDER_RECOMMENDATIONS, { draperyOrderId, type }, { authenticated: true });

export const saveWorkOrderOverrides = (draperyOrderId: number, accountId: number, overrides: Pick<Api.SaveWorkOrderOverridesAction["Request"]["payload"], "panelJson" | "yardages">, draperyOrderPriceId?: number) =>
    Api.createAction(Api.SAVE_WORKORDER_OVERRIDES, {
        draperyOrderId,
        accountId: getScopedAccountId(accountId),
        panelJson: overrides.panelJson,
        yardages: overrides.yardages,
        draperyOrderPriceId
    });

export const uploadWorkOrderPdf = (data: Blob, accountId: number) =>
    Api.createAction(Api.UPLOAD_WORK_ORDER_PDF, { data, accountId: getScopedAccountId(accountId) });
